// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-list {
	position: relative;
	padding-bottom: 16px;
}

.project-list .project-list-header {
	padding: 16px;
	font-size: 21px;
	font-weight: bold;
}

.project-list .project {
	height: 76px;
	position: relative;
	margin-right: 16px;
	margin-left: 16px;
	padding-left: 74px;
	border-bottom: solid 1px #ECECEC;
	cursor: pointer;
}

.project-list .project:last-child {
	border-bottom: none;
}

.project-list .project .project-brand {
	position: absolute;
	left: 0px;
	top: 8px;
	height: 60px;
	width: 60px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	display: inline-block;
}

.project-list .project .project-info {
	display: table-cell;
	vertical-align: middle;
	height: 77px;
	width: 100%;
}

.project-list .project .project-info .project-name {
	font-size: 17px;
}

.project-list .project .project-info .project-organization {
	font-size: 15px;
	color: #9A9A9A;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Dashboard/ProjectList.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,wBAAwB;CACxB,4BAA4B;CAC5B,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;CACtB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,cAAc;AACf","sourcesContent":[".project-list {\n\tposition: relative;\n\tpadding-bottom: 16px;\n}\n\n.project-list .project-list-header {\n\tpadding: 16px;\n\tfont-size: 21px;\n\tfont-weight: bold;\n}\n\n.project-list .project {\n\theight: 76px;\n\tposition: relative;\n\tmargin-right: 16px;\n\tmargin-left: 16px;\n\tpadding-left: 74px;\n\tborder-bottom: solid 1px #ECECEC;\n\tcursor: pointer;\n}\n\n.project-list .project:last-child {\n\tborder-bottom: none;\n}\n\n.project-list .project .project-brand {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 8px;\n\theight: 60px;\n\twidth: 60px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center center;\n\tdisplay: inline-block;\n}\n\n.project-list .project .project-info {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n\theight: 77px;\n\twidth: 100%;\n}\n\n.project-list .project .project-info .project-name {\n\tfont-size: 17px;\n}\n\n.project-list .project .project-info .project-organization {\n\tfont-size: 15px;\n\tcolor: #9A9A9A;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
